"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search404 = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const __1 = require("..");
const Center = app_1.styled.div `
  margin: auto;
  ${(theme) => theme.flexCenter};
  text-align: center;
  > div {
    max-width: 40rem;
    width: 100%;
    margin: 0 ${(theme) => theme.spacing.extraSmall};
  }
`;
const Description = (0, app_1.styled)(app_1.Text) `
  font-size: 1.875rem;
  font-weight: 400;
`;
function Search404({ className, inputProps, }) {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Center, Object.assign({ className: className }, { children: (0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "h1" }, { children: "404" })), (0, jsx_runtime_1.jsx)(Description, Object.assign({ tag: "h2" }, { children: t('error.pageNotFound') })), (0, jsx_runtime_1.jsx)(__1.SearchInput, Object.assign({}, inputProps))] })) })));
}
exports.Search404 = Search404;
